import api from '../../plugins/api';

const getCarDocuments = (params) => {
  return api.get('/api/crm/cars/getCarFiles', params);
};

export default getCarDocuments;
